import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { editUser, getUser, enableUser, disableUser } from '../../../actions/usersActions'
import { getRestaurants } from '../../../actions/restaurantsActions'
import Swal from 'sweetalert2'
import Select from "react-select"

export default function UsersProfile() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
    const navigate = useNavigate()

    const { id } = useParams()

	const {user, resultuser} = useSelector(state=>state.users)
    const {restaurants} = useSelector(state=>state.restaurants)

    const [restaurantsAux, setRestaurantsAux] = useState({});
    const [dataUser, setDataUser] = useState({'password': ''})
    const [isEditing, setIsEditing] = useState(false)
    const [isCorrect, setIsCorrect] = useState("");
    const [passwordverify, setPasswordverify] = useState("")
    
    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handlePasswordVisibilityTwo = () => {
        setShowPasswordTwo(!showPasswordTwo)
    }
    const handleSelectChange = (restaurantSelect) => {

        setDataUser({
            ...dataUser,
            restaurant: restaurantSelect.map(option => option.value)
        })
        setRestaurantsAux({
            ...restaurantsAux,
            selected: restaurantSelect
        })
    }

	useEffect(() => {
		if(client){
            dispatch(getRestaurants())
			dispatch(getUser(id))
		}
	},[dispatch, t, client, id])

    useEffect(() =>{
        setRestaurantsAux(
            {options: restaurants?.map(restaurant => {
                return { label: restaurant.name, value: restaurant._id }
                }),
            selected: []
        })
    },[restaurants])



    useEffect(()=>{
        if (user) {
            setDataUser({...user, 'password': ''})
        }
    }, [user, client, dispatch])

    const handleInputChange = ({target})=>{
        setDataUser({
            ...dataUser,
            [target.name]: target.value
        })
    }

    const checkValidation = (isPassVer, e) => {
        const value = e.target.value;

        let password = dataUser.password;
        let confirm = passwordverify;

        if (isPassVer) {
            confirm = value;
            setPasswordverify(value);
        } else {
            password = value;
            setDataUser({
                ...dataUser,
                password: value
            });
        }

        if (password !== confirm) {
            setIsCorrect("Las contraseñas no coinciden");
        } else {
            setIsCorrect("");
        }
    }

    const handleEdit = async(e) => {
        e.preventDefault()
        setIsEditing(true)
        if(isCorrect === '' || dataUser.password === ''){
            if(dataUser.password?.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,15}$/g) || dataUser.password === ''){
                dispatch(editUser(dataUser, id))
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'warning',
                    text: t('users.passwordsnotvalid')
                })
            }
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.passwordsnotmatch')
            })
        }
        setIsEditing(false)
    }

    const disableEnableUser = async(e) => {
        e.preventDefault()
        let textQuestion = ''
        dataUser.active
            ?
                textQuestion = t('users.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+dataUser.firstname+'</label></p>'
            :
                textQuestion = t('users.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+dataUser.firstname+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (dataUser.active) {
                    dispatch(disableUser(dataUser.id))
                }else{
                    dispatch(enableUser(dataUser.id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.useredit')
                    })
                    navigate('/admin/users')
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/users">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.users.edituser')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5">
                <Form className="px-4 formulario" onSubmit={handleEdit}>

                    {user?.role === 'Kitchen'
                    ?
                        <>
                            <Row className="text-center mt-3">
                                <h2 className="sd-label text-start">{t('admin.users.restaurant')}</h2>
                            </Row>
                            <Row className="text-center mb-3 row-eye">
                                <Select
                                    className="text-start p-0"
                                    isMulti
                                    name="restaurant"
                                    options={restaurantsAux?.options}
                                    value={restaurantsAux?.selected}
                                    onChange={handleSelectChange}
                                    required
                                />
                            </Row>
                        </>
                    :
                        <></>
                    }

                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.users.newname')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type='text'
                            name='firstname'
                            value={dataUser.firstname ||  ''}
                            placeholder={t('admin.users.setname')}
                            onChange={handleInputChange}
                            required
                        />
                        <img className="sd-imageneye" src="../../images/pencil.svg" alt="pencil" width={15}></img>
                    </Row>
                    {dataUser?.birthdate
                        ?
                            <>
                                <Row className="text-center mt-3">
                                    <h2 className="sd-label text-start">{t('admin.users.newphone')}</h2>
                                </Row>
                                <Row className="text-center mb-3 row-eye">
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='phone' 
                                        value={dataUser.phone ||  ''}
                                        placeholder={t('admin.users.setphone')}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <img className="sd-imageneye" src="../../images/pencil.svg" alt="pencil" width={15}></img>
                                </Row>
                                <Row className="text-center mt-3">
                                    <h2 className="sd-label text-start">{t('admin.users.newbirthdate')}</h2>
                                    <Form.Control
                                        className="sd-input sd-input-calendar"
                                        type='date'
                                        name='birthdate' 
                                        value={dataUser.birthdate ||  ''}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Row>
                            </>
                        :
                            <></>
                    }
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.users.newemail')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type='email'
                            name='email' 
                            value={dataUser.email || ''}
                            placeholder={t('admin.users.setemail')}
                            onChange={handleInputChange}
                            required
                        />
                        <img className="sd-imageneye" src="../../images/pencil.svg" alt="pencil" width={15}></img>
                    </Row>
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.users.newpassword')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type={showPasswordOne ? 'text' : 'password'}
                            name='password' 
                            value={dataUser.password ||  ''}
                            placeholder={t('admin.users.setpassword')}
                            onChange={(e) => checkValidation(false, e)}
                        />
                        <img className="sd-imageneye" src={showPasswordOne ? "../../images/eyeclose.svg" : "../../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                    </Row>
                    <Row className="my-3">
                        <p>
                            <span className='fs-12 fw-400 ps-1'>{t('users.passwordneed1')}</span><br/>
                            <span className='password-list'>
                                <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                            </span>
                        </p>
                    </Row>
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.users.passwordconfirm')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type={showPasswordTwo ? 'text' : 'password'}
                            name='passwordcheck'
                            placeholder={t('admin.users.setpasswordconfirm')}
                            onChange={(e) => checkValidation(true, e)}
                        />
                        <img className="sd-imageneye" src={showPasswordTwo ? "../../images/eyeclose.svg" : "../../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityTwo}></img>
                    </Row>
                    <Row className="text-center my-3">
                        <Col>
                            <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                            {isEditing
                                ?
                                    <>
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </>
                                :
                                    <>{t('users.update')}</>
                            }
                            </Button>
                            <Button type="button" className="btn-fourth w-100 my-3" onClick={(e) => disableEnableUser(e)}>
                                <label className='label-button'>{dataUser.active ? t('users.disable') : t('users.enable')}</label>
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
        </Container>
	)
}